
export type ZendeskButtonTypes = typeof ZENDESK_BUTTON_TYPES.fixed | typeof ZENDESK_BUTTON_TYPES.primary;
export const ZENDESK_BUTTON_TYPES = {
    fixed: 'fixed' as const,
    primary: 'primary' as const,
};
